<template>
  <ul class="pagination justify-content-center">
    <li class="page-item" :class="{ disabled: page === 1 }">
      <button class="page-link" @click="paginate(page - 1)">
        <i class="icon-chevron-left"></i>
      </button>
    </li>

    <li
      v-for="i in numberPages"
      :key="i"
      class="page-item"
      :class="{ active: i === page }"
    >
      <button class="page-link" @click="paginate(i)">
        {{ i }}
      </button>
    </li>

    <li class="page-item" :class="{ disabled: page >= numberPages }">
      <button class="page-link" @click="paginate(page + 1)">
        <i class="icon-chevron-right"></i>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 5
    },
    page: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    numberPages() {
      return Math.ceil(this.count / this.limit);
    }
  },
  methods: {
    paginate(page) {
      if (page !== this.page) {
        this.$emit("paginate", page);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  .page-link {
    border: none;
    border-radius: 2px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 2px;
    font-size: 18px;

    i {
      font-size: 24px;
    }
  }

  .disabled {
    opacity: 0.1;
  }

  :not(.active) button {
    color: #f64;
  }

  .active button {
    background: #f64;
    font-weight: bold;
  }
}
</style>
